import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs';
import { ChatLauncherComponent } from './chat/chat-launcher.component';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [RouterOutlet, ChatLauncherComponent],
})
export class AppComponent
{
    /**
     * Constructor
     */ 
    constructor(swUpdate: SwUpdate, private titleService: Title)
    {
        swUpdate.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(evt => {
          if (promptUser(evt)) {
            // Reload the page to update to the latest version.
            document.location.reload();
          }
        });

        // Set dynamic title from organization data (already loaded by initializer)
        const orgName = localStorage.getItem('orgName');
        if (orgName) {
            this.titleService.setTitle(orgName);
        } else {
            this.titleService.setTitle('Admin Portal');
        }
    }
}
function promptUser(evt: VersionReadyEvent) {
    return window.confirm(`New version available! Load New Version?`);
}

